import { CdpEuiccRefreshParams, CdpEuiccRefreshResponse } from "../app/shared/models/layout/cdp/euicc/refresh/CdpEuiccRefresh";

export function response(params: CdpEuiccRefreshParams): CdpEuiccRefreshResponse {
    if (params.eid) return {
        cmd: {
            success: false,
            errorMessages: ["eUICC refresh failed"]
        }
    };
}
